import {FC} from "react";
import styled from "styled-components";

const Value = styled.div`
	font-size: 18px;
	font-weight: 700;
	line-height: 160%;
	font-family: "Khand", sans-serif;
	align-items: center;
	color: ${({theme}) => theme.color.secondary};
`;

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	font-size: 12px;
	line-height: 160%;
	padding: 5px;
	min-width: 87px;
	border-radius: 5px;
	background: ${({theme}) => theme.background.primary};
	color: ${({theme}) => theme.color.primary};
	font-family: "Hind", sans-serif;
`;

interface IStatItem {
	value: string | number;
	name: string;
	className?: string;
}

export const StatItem: FC<IStatItem> = ({value, name, className}) => (
	<Wrapper className={className}>
		<Value>{value}</Value>
		<div>{name}</div>
	</Wrapper>
);
